import script from "./Preloader.vue?vue&type=script&setup=true&lang=js"
export * from "./Preloader.vue?vue&type=script&setup=true&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=e91874b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e91874b2"]])

export default __exports__